module.exports = __webpack_public_path__ + "static/media/image_A2.799b9d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_images/image_A2.png
// module id = 2258
// module chunks = 0